/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Select_Order_PlaceholderInputs */

const en_select_order_placeholder = /** @type {(inputs: Select_Order_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select order...`)
};

const es_select_order_placeholder = /** @type {(inputs: Select_Order_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona un pedido...`)
};

/**
* | output |
* | --- |
* | "Select order..." |
*
* @param {Select_Order_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const select_order_placeholder = /** @type {((inputs?: Select_Order_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Select_Order_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_select_order_placeholder(inputs)
	return es_select_order_placeholder(inputs)
});